import React, { useState } from 'react';
import cx from 'classnames';
import Currency from '../Price';
import { INPUT_SIZES, INPUT_TYPES } from '../../utils/constants';
import style from './input.module.scss';

const Input = ({
	initialValue = '',
	placeholder,
	className,
	containerClassName,
	inputType = INPUT_TYPES.REGULAR,
	size = INPUT_SIZES.SMALL,
	isPrice = true,
	disabled = false,
	onChange,
	...props
}) => {
	const [value, setValue] = useState(initialValue);

	const handleOnChange = ({ value }) => {
		setValue(value || 0);
		onChange?.(value || 0);
	};

	const getInputComponent = () => {
		if (inputType === INPUT_TYPES.CURRENCY) {
			return (
				<Currency
					displayType='input'
					value={value}
					className={cx(style.input, className, {
						[style.hasValue]: value,
						[style.hasPlaceholder]: placeholder,
						[style.big]: size === INPUT_SIZES.BIG,
						[style.small]: size === INPUT_SIZES.SMALL,
					})}
					placeholder={placeholder}
					isPrice={isPrice}
					disabled={disabled}
					onValueChange={handleOnChange}
					{...props}
				/>
			);
		}

		return (
			<input
				value={value}
				className={cx(style.input, className, {
					[style.hasValue]: value,
					[style.hasPlaceholder]: placeholder,
					[style.big]: size === INPUT_SIZES.BIG,
					[style.small]: size === INPUT_SIZES.SMALL,
				})}
				placeholder={placeholder}
				onChange={e => handleOnChange({ value: e.target.value })}
				{...props}
			/>
		);
	};

	return (
		<div className={cx(style.container, containerClassName)}>
			{getInputComponent()}
			{size === INPUT_SIZES.BIG && <span className={style.placeholder}>{placeholder}</span>}
			{size === INPUT_SIZES.BIG && <div className={style.focusedLine}/>}
		</div>

	);
};

export default Input;
